export const PARAMS_FILTER = {
    color: "color", 
    sort: "orderby",
    brand: "brand",
    minPrice: "min_price",
    maxPrice: "max_price",
} 

export const PRODUCTS_PER_PAGE = 10;

export const SHIPPING_FLAT_RATE = 30000;

export const PRICE_RANGE = [25000, 500000]
export const PRICE_STEP = 5000

export const COLOR_LIST = [
  {
    id: 1,
    colorName: 'Green',
    colorValue: 'green',
    hex: '#73BE2F',
  },
  {
    id: 2,
    colorName: 'Grey',
    colorValue: 'grey',
    hex: '#969696',
  },
  {
    id: 3,
    colorName: 'Red',
    colorValue: 'red',
    hex: '#DC464F',
  },
  {
    id: 4,
    colorName: 'White',
    colorValue: 'white',
    hex: '#FFFFFF',
  },
]

export const BRAND_LIST = [
  {
    id: 1,
    brandName: 'Greenies',
    brandValue: 'greenies',
  },
  {
    id: 2,
    brandName: 'Hills Science Diet',
    brandValue: 'hills',
  },
  {
    id: 3,
    brandName: 'Nutro',
    brandValue: 'nutro',
  },
  {
    id: 4,
    brandName: 'Royal Canin',
    brandValue: 'royal',
  },
  {
    id: 5,
    brandName: 'Sophresh',
    brandValue: 'sophresh',
  },
  {
    id: 6,
    brandName: 'Taste of the Wild',
    brandValue: 'taste',
  },
  {
    id: 7,
    brandName: 'Whole Hearted',
    brandValue: 'wholehearted',
  },
  {
    id: 8,
    brandName: 'No Brand',
    brandValue: 'no brand',
  },
]

